import React from "react";
import { Nav, Navbar } from "react-bootstrap";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { useLocation, Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import EGWB from "../../assets/images/EGWB-logo.svg";
import AvatarImage from "../../assets/images/Profile-thumbnail-small.svg";
import { Dropdown, Image } from "react-bootstrap";
import globalFunction from "../../utils/globalFunction";

const LandingPageTopbar = () => {
  const location = useLocation();
  const currentPath = location.pathname;
  const navigate = useNavigate();
  const auth = useSelector((state) => state.auth);

  // Check for active plan instead of pending/inactive
  const hasActivePlan = auth.plans?.some((plan) => plan.status === "active") ?? false;

  // Handler for Dashboard and Profile clicks
  const handleNavigation = (destination) => {
    if (auth.role?.toLowerCase() === "student" && !hasActivePlan) {
      navigate("/choose-plan");
    } else {
      navigate(destination);
    }
  };

  return (
    <div className="top-bar mx-auto" data-aos="fade-up">
      <Navbar
        bg="white"
        data-bs-theme="light"
        className="py-13 px-26 d-flex justify-content-between"
        expand="lg"
      >
        <Navbar.Brand as={Link} to="/" className="logo d-flex align-items-center">
          <LazyLoadImage src={EGWB} alt="EGWB Logo" effect="blur" width={"44"} />
          <div className="fw-semibold pNovaFamily ms-13">
            <span>EGWB</span>
          </div>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="ms-auto me-auto">
            <Nav.Link
              as={Link}
              to="/Features"
              className={`ah-text-md fw-semibold py-10 px-23 ${
                currentPath === "/Features" ? "active" : ""
              }`}
            >
              Features
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/pricing"
              className={`ah-text-md fw-semibold py-10 px-23 ${
                currentPath === "/pricing" ? "active" : ""
              }`}
            >
              Pricing
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/blog"
              className={`ah-text-md fw-semibold py-10 px-23 ${
                currentPath === "/blog" ? "active" : ""
              }`}
            >
              Blog
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/how-its-work"
              className={`ah-text-md fw-semibold py-10 px-23 ${
                currentPath === "/how-its-work" ? "active" : ""
              }`}
            >
              How Its Work
            </Nav.Link>
          </Nav>
          <div className="d-flex align-items-center">
            {auth?.isVerified ? (
              <Dropdown className="auth-dropdown">
                <Dropdown.Toggle className="d-flex align-items-center gap-2 landing-header-signin btn bg-white text-black border-0 py-9 px-22 no-shadow">
                  <strong className="theme-color fw-semibold ah-text-base text-capitalize">
                    {auth.full_name}
                  </strong>
                  <div className="avatar-holder overflow-hidden rounded-circle">
                    <Image
                      src={
                        auth.profilePic?.startsWith("/")
                          ? process.env.REACT_APP_GALLERY_URL + "/" + auth.profilePic
                          : process.env.REACT_APP_GALLERY_URL + auth.profilePic
                      }
                      alt="Instructor"
                      className="w-100 h-100 object-fit-cover p-4 rounded-circle"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = AvatarImage;
                      }}
                    />
                  </div>
                </Dropdown.Toggle>
                <Dropdown.Menu align="end" className="border-theme ah-text-sm">
                  <Dropdown.Item
                    as={Link}
                    to="/dashboard"
                    onClick={(e) => {
                      e.preventDefault();
                      handleNavigation("/dashboard");
                    }}
                  >
                    Dashboard
                  </Dropdown.Item>
                  <Dropdown.Item
                    as={Link}
                    to="/profile"
                    onClick={(e) => {
                      e.preventDefault();
                      handleNavigation("/profile");
                    }}
                  >
                    Profile
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => globalFunction.logoutFunction()}>
                    Logout
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            ) : (
              <>
                <Link to="/login" className="btn btn-light py-9 px-22 me-21 no-shadow">
                  Log in
                </Link>
                <Link to="/user-type" className="btn btn-primary py-9 px-22 no-shadow">
                  Sign Up
                </Link>
              </>
            )}
          </div>
        </Navbar.Collapse>
      </Navbar>
    </div>
  );
};

export default LandingPageTopbar;
